import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const AccountLink = () => {
  const { user } = useAuth();
  return user ? null : <Link to="/login" className="block text-ink-700 hover:text-terracotta">Log in</Link>;
};
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="mt-24 border-t border-parchment-200 bg-parchment-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-8">
        <div className="max-w-sm">
          <div className="flex items-center gap-2.5 mb-3">
            <Logo className="h-9 w-9" />
            <span className="font-serif text-xl font-semibold text-forest-900">SentinelGuide</span>
          </div>
          <p className="text-sm text-ink-500 leading-relaxed">
            Clear, calm guidance for anyone navigating a U.S. criminal case — federal and every state.
          </p>
        </div>
        <div className="flex gap-12 text-sm">
          <div className="space-y-2">
            <p className="font-mono text-xs uppercase tracking-[0.18em] text-ink-400">Explore</p>
            <Link to="/roadmap" className="block text-ink-700 hover:text-terracotta">Case Roadmap</Link>
            <Link to="/diagnostic" className="block text-ink-700 hover:text-terracotta">Case Diagnostic</Link>
            <Link to="/assistant" className="block text-ink-700 hover:text-terracotta">AI Companion</Link>
            <Link to="/resources" className="block text-ink-700 hover:text-terracotta">Resources</Link>
            <Link to="/eligibility" className="block text-ink-700 hover:text-terracotta">Eligibility Calculator</Link>
            <Link to="/bail" className="block text-ink-700 hover:text-terracotta">Bail Estimator</Link>
            <Link to="/guides" data-testid="footer-guides-link" className="block text-ink-700 hover:text-terracotta">State Guides</Link>
            <Link to="/charges" data-testid="footer-charges-link" className="block text-ink-700 hover:text-terracotta">Charge Guides</Link>
          </div>
          <div className="space-y-2">
            <p className="font-mono text-xs uppercase tracking-[0.18em] text-ink-400">Account</p>
            <Link to="/dashboard" className="block text-ink-700 hover:text-terracotta">My Vault</Link>
            <AccountLink />
          </div>
          <div className="space-y-2">
            <p className="font-mono text-xs uppercase tracking-[0.18em] text-ink-400">Legal</p>
            <Link to="/terms" data-testid="footer-terms-link" className="block text-ink-700 hover:text-terracotta">Terms of Service</Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="block text-ink-700 hover:text-terracotta">Privacy Policy</Link>
            <Link to="/disclosures" data-testid="footer-disclosures-link" className="block text-ink-700 hover:text-terracotta">Attorney Directory Disclosures</Link>
          </div>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-parchment-200">
        <p className="text-xs text-ink-400 leading-relaxed max-w-3xl">
          <strong className="text-ink-500">Important:</strong> SentinelGuide provides general legal information and education only.
          It is not a law firm and does not provide legal advice or representation. Always consult a licensed
          criminal defense attorney or public defender for guidance about your specific situation.
        </p>
      </div>
    </div>
  </footer>
);
